(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3065],{

/***/ 84137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useWindowEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useWindowEvent(type, listener, options) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    window.addEventListener(type, listener, options);
    return () => window.removeEventListener(type, listener, options);
  }, []);
}


//# sourceMappingURL=use-window-event.js.map


/***/ }),

/***/ 72128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useWindowScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_window_event_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84137);



function getScrollPosition() {
  return typeof window !== "undefined" ? { x: window.pageXOffset, y: window.pageYOffset } : { x: 0, y: 0 };
}
function scrollTo({ x, y }) {
  if (typeof window !== "undefined") {
    const scrollOptions = { behavior: "smooth" };
    if (typeof x === "number") {
      scrollOptions.left = x;
    }
    if (typeof y === "number") {
      scrollOptions.top = y;
    }
    window.scrollTo(scrollOptions);
  }
}
function useWindowScroll() {
  const [position, setPosition] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getScrollPosition());
  (0,_use_window_event_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .s)("scroll", () => setPosition(getScrollPosition()));
  (0,_use_window_event_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .s)("resize", () => setPosition(getScrollPosition()));
  return [position, scrollTo];
}


//# sourceMappingURL=use-window-scroll.js.map


/***/ }),

/***/ 85601:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog",
      function () {
        return __webpack_require__(22986);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ButtonLoading = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: "mr-2 h-5 w-5 animate-spin ".concat(color),
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonLoading);


/***/ }),

/***/ 34593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);





var CatalogKlassCard = function(param) {
    var course = param.course;
    var courseType = course.courseType, id = course.id, title = course.title, image = course.image, tags = course.tags, price = course.price, promotion = course.promotion, promotionPrice = course.promotionPrice;
    var tagRefs = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)([]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), truncateIndex = ref[0], setTruncateIndex = ref[1];
    var detailUrl = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return courseType === "kdc" ? "/onboarding/".concat(id) : "/courses/technology/".concat(id);
    }, [
        courseType,
        id
    ]);
    var isPromotionActive = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return promotion !== null && ((promotion === null || promotion === void 0 ? void 0 : promotion.promotionRate) > 0 || (promotion === null || promotion === void 0 ? void 0 : promotion.promotionAmount) > 0);
    }, [
        promotion
    ]);
    var promotionRate = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        if ((promotion === null || promotion === void 0 ? void 0 : promotion.promotionType) === null) return 0;
        if ((promotion === null || promotion === void 0 ? void 0 : promotion.promotionType) === "rate") return promotion.promotionRate;
        else if ((promotion === null || promotion === void 0 ? void 0 : promotion.promotionType) === "amount") {
            var rate = (promotion === null || promotion === void 0 ? void 0 : promotion.promotionAmount) / price;
            return Math.floor((rate > 1 ? 1 : rate) * 100);
        }
        return 0;
    }, [
        price,
        promotion
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useLayoutEffect)(function() {
        if (tagRefs.current && tags) {
            var ref, ref1;
            var containerWidth = ((ref = tagRefs.current[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.parentElement) === null || ref1 === void 0 ? void 0 : ref1.offsetWidth) || 0;
            var totalWidth = 0;
            for(var i = 0; i < tags.length; i++){
                var ref2;
                var tagWidth = ((ref2 = tagRefs.current[i]) === null || ref2 === void 0 ? void 0 : ref2.offsetWidth) || 0;
                totalWidth += tagWidth;
                if (totalWidth > containerWidth) {
                    setTruncateIndex(i);
                    break;
                }
            }
        }
    }, [
        tags,
        tagRefs
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: detailUrl,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
            className: "relative flex cursor-pointer flex-col",
            children: [
                image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative aspect-[3/2] w-full",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: image,
                        alt: "klass_catalog_image",
                        layout: "fill",
                        objectFit: "cover",
                        className: "rounded-md md:rounded-xl"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "aspect-[3/2] w-full rounded-md bg-gray-100 md:rounded-xl"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "mt-2.5 line-clamp-2 text-sm md:text-lg",
                    children: title
                }),
                !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(tags) && tags && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "mt-1.5 flex flex-row space-x-1 overflow-hidden md:mt-1 lg:mt-2 lg:space-x-1.5",
                    children: tags === null || tags === void 0 ? void 0 : tags.map(function(tag, idx) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            ref: function(el) {
                                return tagRefs.current[idx] = el;
                            },
                            className: "whitespace-nowrap rounded bg-gray-100 px-1 py-0.5 text-xs text-gray-400 lg:px-1.5 lg:text-base ".concat(truncateIndex === idx ? "truncate" : ""),
                            style: {
                                display: truncateIndex !== null && idx >= truncateIndex + 1 ? "none" : "inline-block"
                            },
                            children: tag.name
                        }, "klass_tag_".concat(idx));
                    })
                }),
                courseType === "kdc" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "mt-2.5 text-xs text-gray-400 line-through md:text-sm lg:mt-3 lg:text-base",
                            children: [
                                price.toLocaleString(),
                                "원"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "space-x-1 md:mt-0.5 lg:space-x-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-sm font-semibold text-yellow-450 md:text-base lg:text-lg",
                                    children: "국비지원시"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "text-sm font-semibold md:text-base lg:text-lg",
                                    children: [
                                        (Math.round(price * 0.1 / 10) * 10).toLocaleString(),
                                        "원"
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: promotion && promotionPrice && isPromotionActive ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "mt-2.5 flex lg:mt-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "mr-1 text-sm font-medium text-yellow-450 lg:text-base xl:mr-2 xl:text-xl xl:font-semibold",
                                children: [
                                    promotionRate,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-sm font-semibold md:text-base xl:text-xl",
                                children: [
                                    promotionPrice.toLocaleString(),
                                    "원"
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "mt-2.5 text-sm font-semibold md:text-base lg:mt-3 lg:text-lg",
                        children: [
                            price.toLocaleString(),
                            "원"
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CatalogKlassCard);


/***/ }),

/***/ 50687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useKlassCategoryListQuery; }
/* harmony export */ });
/* unused harmony export fetchKlassCategoryList */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36492);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_convertString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79379);





var fetchKlassCategoryList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(type) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().get("".concat(window.apiEndpoint, "/course/v1/category?filters=type:").concat(type, "&sort=order:asc"))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,utils_convertString__WEBPACK_IMPORTED_MODULE_1__/* .convertCaseList */ ._b)(res.data, utils_convertString__WEBPACK_IMPORTED_MODULE_1__/* .ConvertType.CAMEL */ .xb.CAMEL)
                    ];
            }
        });
    });
    return function fetchKlassCategoryList(type) {
        return _ref.apply(this, arguments);
    };
}();
var useKlassCategoryListQuery = function(type) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)({
        queryKey: [
            "category",
            type
        ],
        queryFn: function() {
            return fetchKlassCategoryList(type);
        }
    });
};


/***/ }),

/***/ 67604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ renderAiToast; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72132);


var renderAiToast = function() {
    react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: "whitespace-nowrap text-sm font-semibold text-primary-normal lg:text-lg",
        children: "AI가 추천한 맞춤 강의로 이동할게요"
    }), {
        toastId: "aiToast",
        className: "top-6 px-4 lg:px-5 py-2.5 lg:top-12 rounded-full mx-auto border-2 border-primary w-auto shadow-[0px_10px_66px_0px_rgba(189, 97, 27, 0.10)]",
        bodyClassName: "p-0 flex items-center justify-center text-sm lg:text-base font-semibold",
        closeButton: false,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex h-6 w-[42px] shrink-0 items-center justify-center lg:h-[30px] lg:w-15",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "https://d35ai18pny966l.cloudfront.net/course/home/icon_AI.png",
                alt: "check icon",
                className: "w-full"
            })
        }),
        style: {
            backgroundColor: "white",
            width: "100%"
        },
        transition: react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .Zoom */ .LG
    });
};


/***/ }),

/***/ 22986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ catalog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-media-query/use-media-query.js
var use_media_query = __webpack_require__(34065);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-window-scroll/use-window-scroll.js
var use_window_scroll = __webpack_require__(72128);
// EXTERNAL MODULE: ./designs/Loading/index.tsx
var Loading = __webpack_require__(3790);
// EXTERNAL MODULE: ./designs/Loading/ButtonLoading.tsx
var ButtonLoading = __webpack_require__(97623);
// EXTERNAL MODULE: ./features/catalog/components/CatalogKlassCard/index.tsx
var CatalogKlassCard = __webpack_require__(34593);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./utils/convertString.ts
var convertString = __webpack_require__(79379);
;// CONCATENATED MODULE: ./features/catalog/queries/useKlassCategoryItemsListQuery.ts





var fetchKlassCategoryItemsList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(type, category) {
        var sort, page, perPage, res;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sort = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "-order", page = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 1, perPage = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : 10;
                    return [
                        4,
                        axios_default().get("".concat(window.apiEndpoint, "/course/v1/category/course?type=").concat(type, "&category=").concat(category, "&is_visible=true&sort=").concat(sort, "&page=").concat(page, "&per_page=").concat(perPage))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,convertString/* convertCaseList */._b)(res.data, convertString/* ConvertType.CAMEL */.xb.CAMEL)
                    ];
            }
        });
    });
    return function fetchKlassCategoryItemsList(type, category) {
        return _ref.apply(this, arguments);
    };
}();
// 페이별 페이지네이션
var useKlassCategoryItemsListQuery = function(type, category) {
    var sort = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "-order", page = arguments.length > 3 ? arguments[3] : void 0, perPage = arguments.length > 4 ? arguments[4] : void 0;
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            "category-items",
            type,
            category,
            sort,
            page,
            perPage
        ],
        queryFn: function() {
            return fetchKlassCategoryItemsList(type, category, sort, page, perPage);
        }
    });
};
// 무한스크롤 페이지네이션
var useInfiniteKlassCategoryItemsListQuery = function(type, category) {
    var sort = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "-order", perPage = arguments.length > 3 ? arguments[3] : void 0;
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            "infinite-category-items",
            type,
            category,
            sort
        ],
        queryFn: function(param) {
            var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
            return fetchKlassCategoryItemsList(type, category, sort, pageParam, perPage);
        },
        getNextPageParam: function(list) {
            if (list.pagination.page < list.pagination.totalPage) {
                return list.pagination.page + 1;
            }
            return undefined;
        }
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./features/catalog/components/CatalogMenu/CatalogMenu.module.scss
var CatalogMenu_module = __webpack_require__(82185);
var CatalogMenu_module_default = /*#__PURE__*/__webpack_require__.n(CatalogMenu_module);
;// CONCATENATED MODULE: ./features/catalog/components/CatalogMenu/index.tsx









var CatalogMenu = function(param) {
    var menuType = param.menuType, category = param.category, klassCategoryList = param.klassCategoryList, isScrolling = param.isScrolling;
    var router = (0,next_router.useRouter)();
    var scrollRef = (0,react.useRef)(null);
    var itemRefs = (0,react.useRef)([]);
    var curCategoryIndex = klassCategoryList.findIndex(function(item) {
        return item.category === category;
    });
    var ref = (0,react.useState)(true), isAtLastIndex = ref[0], setIsAtLastIndex = ref[1];
    var handleScroll = function() {
        if (scrollRef.current) {
            var currentScrollRef = scrollRef.current;
            var scrollWidth = currentScrollRef.scrollWidth, clientWidth = currentScrollRef.clientWidth, scrollLeft = currentScrollRef.scrollLeft;
            setIsAtLastIndex(scrollWidth > clientWidth && scrollLeft < scrollWidth - clientWidth);
        }
    };
    var handleCategoryClick = function(category) {
        void router.push({
            pathname: "/catalog",
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                category: category,
                sort: "-order"
            })
        });
    };
    var scrollToIndex = function(index) {
        var selectedElement = itemRefs.current[index];
        if (selectedElement) {
            var ref;
            (ref = selectedElement.parentElement) === null || ref === void 0 ? void 0 : ref.scrollTo({
                left: selectedElement.offsetLeft - 16,
                behavior: "smooth"
            });
        }
    };
    (0,react.useLayoutEffect)(function() {
        if (curCategoryIndex !== -1) {
            var observer = new MutationObserver(function() {
                if (itemRefs.current[curCategoryIndex]) {
                    setTimeout(function() {
                        return scrollToIndex(curCategoryIndex);
                    }, 100);
                    observer.disconnect();
                }
            });
            if (scrollRef.current) {
                observer.observe(scrollRef.current, {
                    childList: true,
                    subtree: true
                });
            }
            return function() {
                return observer.disconnect();
            };
        }
    }, [
        category,
        klassCategoryList,
        curCategoryIndex
    ]);
    (0,react.useEffect)(function() {
        if (isScrolling) {
            if (curCategoryIndex !== -1) {
                scrollToIndex(curCategoryIndex);
            }
        }
    }, [
        isScrolling,
        curCategoryIndex,
        klassCategoryList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: menuType === "button" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full bg-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: scrollRef,
                        className: "mx-auto flex space-x-2 overflow-x-auto px-4 py-3 md:justify-center md:space-x-2 md:px-6 lg:max-w-7xl lg:space-x-4 ".concat((CatalogMenu_module_default()).scrollHidden),
                        children: klassCategoryList.map(function(data, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: function(el) {
                                    return itemRefs.current[idx] = el;
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CatalogMenuItem, {
                                    menuType: "button",
                                    curCategory: category,
                                    data: data,
                                    onCategoryClick: handleCategoryClick
                                })
                            }, "catalog_".concat(idx, "_button"));
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-6 ".concat((CatalogMenu_module_default()).menuShadow)
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative w-full bg-white",
            children: [
                isAtLastIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:hidden ".concat((CatalogMenu_module_default()).menuScrollableShadow)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: scrollRef,
                    onScroll: handleScroll,
                    className: "mx-auto flex overflow-x-auto pr-4 md:justify-center md:space-x-1 md:px-4 lg:max-w-7xl lg:space-x-2 ".concat((CatalogMenu_module_default()).scrollHidden),
                    children: klassCategoryList.map(function(data, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: function(el) {
                                return itemRefs.current[idx] = el;
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CatalogMenuItem, {
                                menuType: "imageButton",
                                curCategory: category,
                                data: data,
                                onCategoryClick: handleCategoryClick
                            })
                        }, "catalog_".concat(idx, "_image_button"));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_CatalogMenu = (CatalogMenu);
var CatalogMenuItem = function(param) {
    var menuType = param.menuType, data = param.data, curCategory = param.curCategory, onCategoryClick = param.onCategoryClick;
    var category = data.category, name = data.name, image = data.image;
    var ref = useKlassCategoryItemsListQuery("catalog", category), klassCategoryItems = ref.data;
    var isCurrent = curCategory === category;
    var showMenu = (0,react.useMemo)(function() {
        return !(0,lodash.isEmpty)(klassCategoryItems === null || klassCategoryItems === void 0 ? void 0 : klassCategoryItems.data);
    }, [
        curCategory,
        klassCategoryItems, 
    ]);
    // if (!showMenu) return null
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: menuType === "button" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function() {
                return onCategoryClick(category);
            },
            className: "rounded-full px-3 py-2 ".concat(isCurrent ? "borer border-gray-800 bg-gray-800 text-white" : "border border-gray-200"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "whitespace-nowrap break-words break-keep text-sm md:text-base",
                children: name
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            onClick: function() {
                return onCategoryClick(category);
            },
            className: "flex w-[84px] min-w-[84px] flex-col items-center space-y-2 md:w-[96px] md:min-w-[96px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative h-12 w-12 overflow-hidden rounded-[18px] lg:h-16 lg:w-16 lg:rounded-3xl ".concat(isCurrent ? (CatalogMenu_module_default()).imageButtonShadow : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image || "https://d35ai18pny966l.cloudfront.net/course/notice_boards/empty_file_img.png",
                        alt: "catalog_category_img",
                        layout: "fill",
                        className: "object-cover"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "whitespace-nowrap break-words break-keep text-sm md:text-base ".concat(isCurrent ? "font-semibold text-yellow-450" : "text-gray-500"),
                    children: name
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./features/catalog/consts/index.ts
var CATALOG_KDC_BANNER_HEADLINE = {
    mobile: "최대 2개 기초 국비강의 보러 가기",
    laptop: "최대 두 개까지 국비지원되는 기초 강의 들으러 가기!"
};
var CATALOG_NEBECA_BANNER_HEADLINE = {
    mobile: "내일배움카드가 없다면?",
    laptop: "내일배움카드 신청하고 국비지원 혜택으로 멋사교육 들으러 가기"
};
var CATALOG_SORT_OPTIONS = [
    {
        value: "-order",
        label: "인기순"
    },
    {
        value: "-created_at",
        label: "최신순"
    }, 
];

;// CONCATENATED MODULE: ./features/catalog/components/CatalogSortedButton/index.tsx





var CatalogSortedButton = function(param) {
    var sort = param.sort;
    var router = (0,next_router.useRouter)();
    var handleCategoryClick = function(sort) {
        void router.push({
            pathname: "/catalog",
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                sort: sort
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "rounded-lg bg-gray-100 p-1",
        children: CATALOG_SORT_OPTIONS.map(function(option) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    return handleCategoryClick(option.value);
                },
                className: "inline-flex items-center justify-center px-2 py-1.5 text-xs md:text-sm  ".concat(sort === option.value ? "rounded-md bg-white font-semibold" : "text-gray-400"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: option.label
                })
            }, option.value);
        })
    });
};
/* harmony default export */ var components_CatalogSortedButton = (CatalogSortedButton);

// EXTERNAL MODULE: ./features/catalog/queries/useKlassCategoryListQuery.ts
var useKlassCategoryListQuery = __webpack_require__(50687);
// EXTERNAL MODULE: ./features/common/components/Toast/AiToast.tsx
var AiToast = __webpack_require__(67604);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ./shared/layout/WithHeader/index.tsx + 1 modules
var WithHeader = __webpack_require__(89123);
// EXTERNAL MODULE: ./pages/catalog/Catalog.module.scss
var Catalog_module = __webpack_require__(30331);
var Catalog_module_default = /*#__PURE__*/__webpack_require__.n(Catalog_module);
;// CONCATENATED MODULE: ./pages/catalog/index.tsx
















var CatalogDetail = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,use_media_query/* useMediaQuery */.a)("(max-width: 767px)");
    var isTablet = (0,use_media_query/* useMediaQuery */.a)("(min-width: 768px) and (max-width: 1023px)");
    var ref1 = (0,react_intersection_observer/* useInView */.YD)(), ref2 = ref1.ref, inView = ref1.inView;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,use_window_scroll/* useWindowScroll */.b)(), 1), scroll = ref3[0];
    var isScrolling = isMobile ? scroll.y > 60 : scroll.y > 90;
    var ref4 = (0,useKlassCategoryListQuery/* useKlassCategoryListQuery */.j)("catalog"), klassCategoryList = ref4.data, isLoadingKlassCategoryList = ref4.isLoading;
    var category = router.query.category || "all";
    var categoryName = (0,react.useMemo)(function() {
        if (klassCategoryList) {
            var ref;
            var name = (ref = klassCategoryList.find(function(item) {
                return item.category === category;
            })) === null || ref === void 0 ? void 0 : ref.name;
            if (category === "all") return "".concat(name, " 강의");
            return name;
        }
    }, [
        category,
        klassCategoryList
    ]);
    var sort = router.query.sort || "-order";
    var perPage = isMobile ? 6 : isTablet ? 9 : 12;
    var isFromHomeAi = router.query.home;
    (0,react.useEffect)(function() {
        if (isFromHomeAi) (0,AiToast/* renderAiToast */.H)();
    }, []);
    var ref5 = useInfiniteKlassCategoryItemsListQuery("catalog", category, sort, perPage), klassCategoryItems = ref5.data, fetchNextPage = ref5.fetchNextPage, hasNextPage = ref5.hasNextPage, isFetchingNextPage = ref5.isFetchingNextPage;
    (0,react.useEffect)(function() {
        if (inView && hasNextPage) {
            void fetchNextPage();
        }
    }, [
        inView,
        hasNextPage,
        fetchNextPage
    ]);
    (0,react.useEffect)(function() {
        window.scrollTo(window.scrollX, 0);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WithHeader/* default */.Z, {
        children: [
            isLoadingKlassCategoryList && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative w-full pb-20 pt-6 md:pb-30 lg:pb-40 lg:pt-12",
                style: {
                    minWidth: 360
                },
                children: [
                    klassCategoryList && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "fixed z-100 w-full lg:sticky ".concat((Catalog_module_default()).menuContainer, " "),
                                children: isScrolling && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-down",
                                    "data-aos-easing": "ease",
                                    "data-aos-duration": "600",
                                    "data-aos-delay": "300",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CatalogMenu, {
                                        menuType: "button",
                                        category: category,
                                        klassCategoryList: klassCategoryList,
                                        isScrolling: isScrolling
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "z-10 w-full ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CatalogMenu, {
                                    menuType: "imageButton",
                                    category: category,
                                    klassCategoryList: klassCategoryList,
                                    isScrolling: isScrolling
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "mx-auto w-full px-4 pt-8 lg:max-w-7xl lg:px-6 lg:pt-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                className: "flex items-center justify-between",
                                children: [
                                    klassCategoryList && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-lg font-semibold md:text-2xl md:font-bold lg:text-4xl",
                                        children: categoryName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CatalogSortedButton, {
                                        sort: sort
                                    })
                                ]
                            }),
                            klassCategoryItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                className: "mt-4 lg:mt-6",
                                children: categoryName === "6주완성" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center justify-center py-20 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/svg/icon_people.svg",
                                            alt: "people icon",
                                            className: "".concat(isMobile ? "mb-4 h-[180px] w-[180px]" : "mb-6 h-[250px] w-[250px]")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base font-normal leading-[1.63] text-neutral-400",
                                            children: "6주 완성 강의가 새로워 집니다."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-[6px] text-base font-normal leading-[1.63] text-neutral-400",
                                            children: isMobile ? "더 알찬 강의로 다시 찾아뵙겠습니다." : "더 알찬 강의로 다시 찾아뵐 예정이니 기대해 주세요!"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    void router.push({
                                                        pathname: "/catalog",
                                                        query: {
                                                            category: "all"
                                                        }
                                                    });
                                                },
                                                className: "h-[44px] w-[220px] rounded-[8px] bg-yellow-450 text-white",
                                                children: "전체강의 둘러보기"
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        (ref = klassCategoryItems.pages) === null || ref === void 0 ? void 0 : ref.map(function(page, pageIdx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-10 grid grid-cols-2 gap-x-4 gap-y-10 first:mt-0 md:mt-12 md:grid-cols-3 md:gap-x-5 md:gap-y-12 lg:md:grid-cols-4 lg:gap-x-6",
                                                children: page.data.map(function(course, idx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CatalogKlassCard/* default */.Z, {
                                                        course: course
                                                    }, "".concat(course.id, "_catalog_").concat(idx));
                                                })
                                            }, "$catalog_page_".concat(pageIdx));
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: ref2
                                        }),
                                        isFetchingNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-4 flex justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLoading/* default */.Z, {
                                                color: "text-yellow-450"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var catalog = (CatalogDetail);


/***/ }),

/***/ 82185:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"scrollHidden":"CatalogMenu_scrollHidden__HO74P","menuShadow":"CatalogMenu_menuShadow__3gxdp","imageButtonShadow":"CatalogMenu_imageButtonShadow__jPfZx","menuScrollableShadow":"CatalogMenu_menuScrollableShadow__7rxwY"};

/***/ }),

/***/ 30331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"scrollHidden":"Catalog_scrollHidden__Pcd0_","menuContainer":"Catalog_menuContainer__Sx_Ci"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,6408,4653,3607,346,5966,9464,1244,3881,361,9774,2888,179], function() { return __webpack_exec__(85601); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);